import axios from 'axios';
import { get, set } from './Storage';

var UserSettings = {
    preferredDeposit: [],
    preferredWithdrawal: [],
    toolbarMode: "full",
}


var setSetting = function (UserSettings) {
    var AppSettings = get();
    if (!AppSettings.usersettings) {
        return false;
    }

    var url = AppSettings['env'].urlUserBoxSetUserSettings;
    var post = { setting: { group: "UserBox", value: JSON.stringify(UserSettings) }, sessionToken: "" };
    axios.post(url, post)
        .then(({ data, status, statusText }) => { })
        .catch(function (error) { });

    return true;
}

var getSetting = function () {
    var AppSettings = get();
    if (!AppSettings.usersettings) {
        return false;
    }
    var url = AppSettings['env'].urlUserBoxGetUserSettings;
    return axios.get(url)
        .then(({ data, status, statusText }) => {


        })
        .catch(() => {

        });

}
export { UserSettings, setSetting, getSetting };